module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"required_item_locked","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"levelUnlocked":{"type":"boolean"},"playerLevel":{"type":"integer"},"item":{"type":"string"},"label":{"type":"string"},"level":{"type":"string"}},"required":["user","level","item"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/required_item_locked.json
// module id = 565
// module chunks = 100